import { takeLatest } from 'redux-saga/effects';
import { CREATE_ADD_STOCK_REQUEST } from '../../redux/modules/addStock/addStock-actions';
import createAddStockWorker from './addStockWorkerSaga';

export default function* createAddStockWatcher() {
    yield takeLatest(CREATE_ADD_STOCK_REQUEST, createAddStockWorker);
}
